import { makeAutoObservable } from 'mobx'

// Evertel
import { decorate, inject, injectable } from '@evertel/di'
import { ConsumeInviteController, InviteResult } from '@evertel/invites'
import { SessionService } from '@evertel/session/SessionService'
import { DepartmentController } from '@evertel/department'
import { CurrentUserController } from '@evertel/blue-user'

class InviteActionHandler {

    constructor(
        private sessionService: SessionService,
        private departmentController: DepartmentController,
        private consumeInviteController: ConsumeInviteController,
        private currentUserController: CurrentUserController
    ) {
        makeAutoObservable(this)
    }

    consumePendingAction = async (navigate, addToast) => {
        const pendingInviteToken = this.consumeInviteController.pendingInviteToken
        try {
            const response = await this.consumeInviteController.consumePendingInvite()
            return this.action(response, addToast, navigate)
        } catch (err: any) {
            addToast({
                title: `There was an issue with your invite (${pendingInviteToken || ''}).`,
                message: String(err.message),
                color: 'danger'
            })
        }
    }

    /**
     * Can be called anywhere we consume any invite
     * @param response
     * @param addToast
     * @param navigate
     * @returns
     */
    action = async (response: InviteResult, addToast, navigate) => {
        if (!response) return
        switch (response?.action) {
            case 'ROOM_INVITE':
                this.sessionService.setSelectedDeparmentId(response.departmentsAccess.departmentId)
                navigate(`/room/${response.room.id}`)
                break
            case 'USER_INVITE':
                navigate(`/thread/${response.thread.id}`)
                break
            case 'DEPARTMENT_INVITE': {
                this.sessionService.setSelectedDeparmentId(response.departmentsAccess.departmentId)
                await this.departmentController.init(response.departmentsAccess.departmentId)

                // Only show the modal if user has multiple departments (excluding guests)
                const userDepartments = this.currentUserController.departmentsAccessNotGuest
                if (userDepartments.length > 1) {
                    addToast({
                        title: 'You have switched agencies',
                        message: 'You are now viewing ' + (this.departmentController.department?.name || 'your new agency') + '.',
                        color: 'success'
                    })
                }
                break
            }
            default:
                break
        }
    }
}

let i = 0
decorate(injectable(), InviteActionHandler)
decorate(inject(SessionService), InviteActionHandler, i++)
decorate(inject(DepartmentController), InviteActionHandler, i++)
decorate(inject(ConsumeInviteController), InviteActionHandler, i++)
decorate(inject(CurrentUserController), InviteActionHandler, i++)


export { InviteActionHandler }
